import { SkyView } from "../../SkyView/SkyView";

export function Page() {
  return <SkyView />;
}
